import { render } from "./SubscriptionTermsSection.vue?vue&type=template&id=2040eaa0&scoped=true"
import script from "./SubscriptionTermsSection.vue?vue&type=script&lang=js"
export * from "./SubscriptionTermsSection.vue?vue&type=script&lang=js"

import "./SubscriptionTermsSection.vue?vue&type=style&index=0&id=2040eaa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2040eaa0"]])

export default __exports__